/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:81a3e591-0e5a-4018-af1f-04fec350b995",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_qZjGHzk3L",
    "aws_user_pools_web_client_id": "5h6i4bgh53jvifaqq2pk1jgebl",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://h6rrbwiygfabpl5bcfkwblmcbi.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
